module.exports = __webpack_public_path__ + "static/media/ava.7857b48c.svg";